const contributorRolesData = {
  count: 8,
  next: null,
  previous: null,
  results: [
    {
      id: 1,
      name: "Arranger",
    },
    {
      id: 2,
      name: "Composer",
    },
    {
      id: 3,
      name: "Conductor",
    },
    {
      id: 5,
      name: "Lyricist",
    },
    {
      id: 6,
      name: "Engineer",
    },
    {
      id: 7,
      name: "Mixer",
    },
    {
      id: 8,
      name: "Orchestra",
    },
    {
      id: 9,
      name: "Producer",
    },
  ],
};

export default contributorRolesData;
